import { render } from "./SzUploadMore.vue?vue&type=template&id=317ebcaa&scoped=true"
import script from "./SzUploadMore.vue?vue&type=script&lang=ts"
export * from "./SzUploadMore.vue?vue&type=script&lang=ts"

import "./SzUploadMore.vue?vue&type=style&index=0&id=317ebcaa&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-317ebcaa"

export default script